export default "__VITE_ASSET__50f86d56__"